import React, { Component } from "react";

export default class KirokuButtonLink extends Component {
    render() {
        return (
            <button {...this.props} className={`${this.props.className} btn btn-kiroku-link`}>{this.props.children}</button>
        )
    }
}
